module.exports = __webpack_public_path__ + "img/Suv_Front_Side_Left_Transparent.5ce13270.svg";